// @mui material components
import Grid from "@mui/material/Grid";

import { useEffect, useState } from "react";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import ScorecardsPage from "./components/scorecardspage.js";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout/index.js";
import DashboardNavbar from "examples/Navbars/DashboardNavbar/index.js";
import KPIPage from "./components/kpipage.js/index.js";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAuth } from "context/authContext.js";
import { hasEditAccess } from "services/utils.js";
import { buttonStyles } from "services/utils.js";
import UserScorecardsView from "./components/scorecards/index.js";

function KpisView() {
  const { t } = useTranslation();
  const { employee, modules } = useAuth();
  const [view, setView] = useState(0);
  const [canEdit, setCanEdit] = useState(false);

  useEffect(() => {
    setCanEdit(hasEditAccess(modules, "Performance", employee));
  }, [canEdit, employee, modules]);
  // Common button styles

  return (
    <>
      <MDBox>
        {/* Button group container */}
        <MDBox
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }} // Stack on xs, row on sm+
          gap={1} // Uniform spacing between buttons
          mb={2} // Margin bottom to separate from the page content
        >
          <Button
            sx={{ ...buttonStyles(view === 0), width: { xs: "100%", sm: "auto" } }}
            variant={view === 0 ? "contained" : "outlined"}
            onClick={() => setView(0)}
            color="primary"
          >
            {t("admin.inventory.manageKPIs")}
          </Button>
          <Button
            sx={{ ...buttonStyles(view === 1), width: { xs: "100%", sm: "auto" } }}
            variant={view === 1 ? "contained" : "outlined"}
            onClick={() => setView(1)}
          >
            {t("admin.inventory.manageScorecards")}
          </Button>
          {/* 3. NEW BUTTON: User Scorecards (Audit/View) */}
          {employee?.role == 1 && (
            <Button
              sx={{ ...buttonStyles(view === 2), width: { xs: "100%", sm: "auto" } }}
              variant={view === 2 ? "contained" : "outlined"}
              onClick={() => setView(2)}
              color="primary"
            >
              {t("admin.inventory.viewScorecards")}
            </Button>
          )}
        </MDBox>

        {/* Conditionally render pages */}
        {view === 0 ? (
          <KPIPage canEdit={canEdit} />
        ) : view === 1 ? (
          <ScorecardsPage canEdit={canEdit} />
        ) : (
          employee?.role == 1 && <UserScorecardsView />
        )}
      </MDBox>
    </>
  );
}

export default KpisView;
